import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const NavLinks = styled(motion.div)<{ $isColumn?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(props) => (props.$isColumn ? 'column' : 'row')};
  width: 100%;
`

const NavLink = styled(motion.div)`
  position: relative;
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  &:hover {
    color: #4ecdc4;
    text-shadow: 0 0 10px rgba(78, 205, 196, 0.5);
  }
  &.active {
    color: #4ecdc4;
    text-shadow: 0 0 10px rgba(78, 205, 196, 0.5);
  }
`

const linkVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  hover: { scale: 1.1, transition: { duration: 0.2 } },
}

interface NavigationProps {
  isColumn?: boolean
}

export const Navigation: React.FC<NavigationProps> = ({ isColumn = false }) => {
  const location = useLocation()
  return (
    <NavLinks $isColumn={isColumn}>
      <Link to='/' style={{ textDecoration: 'none' }}>
        <NavLink
          variants={linkVariants}
          whileHover='hover'
          className={location.pathname === '/' ? 'active' : ''}>
          Home
        </NavLink>
      </Link>
      <Link to='/projects' style={{ textDecoration: 'none' }}>
        <NavLink
          variants={linkVariants}
          whileHover='hover'
          className={location.pathname === '/projects' ? 'active' : ''}>
          Projects
        </NavLink>
      </Link>
      <Link to='/skills' style={{ textDecoration: 'none' }}>
        <NavLink
          variants={linkVariants}
          whileHover='hover'
          className={location.pathname === '/skills' ? 'active' : ''}>
          Skills
        </NavLink>
      </Link>
      <Link to='/contact' style={{ textDecoration: 'none' }}>
        <NavLink
          variants={linkVariants}
          whileHover='hover'
          className={location.pathname === '/contact' ? 'active' : ''}>
          Contact
        </NavLink>
      </Link>
    </NavLinks>
  )
}
